import { render, staticRenderFns } from "./WhatIsDexilon.vue?vue&type=template&id=b4b82dfc&scoped=true&"
import script from "./WhatIsDexilon.vue?vue&type=script&lang=js&"
export * from "./WhatIsDexilon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b82dfc",
  null
  
)

export default component.exports